import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { SmallHeading } from '../typography';

export const SponsorContainer = styled.section`
  padding: 50px 10px 100px 10px;
`;

export const SponsorWrapper = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  text-align: center;

  @media (${tabletMax}) {
    ${SmallHeading} {
      font-size: 18px;
    }
  }
`;
